<app-header></app-header>

<!-- Page title section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg')">
    <div class="bg-dark-05">
        <div class="container text-center z-index-1">
            <h1 class="fw-bold uppercase letter-spacing-1 m-0">404 Error Page</h1>
        </div><!-- end container -->
    </div>
</div>
<!-- end Page title section -->

<div class="section-fullscreen">
    <div class="container">
        <div class="position-middle">
            <div class="row g-4">
                <div class="col-12">
                    <h1 class="display-2 fw-bold text-gradient-1 line-height-160">404 Error! Page Not Found.</h1>
                    <h5 class="fw-light text-dark-05">The page you're looking for might have been moved, deleted, or never existed.</h5>
                    <a class="button button-lg button-rounded button-font-2 button-gradient-1 mt-4" routerLink="/"><i class="fas fa-home"></i><span>Go home page</span></a>
                </div>
            </div><!-- end row -->
        </div><!-- end position-middle -->
    </div><!-- end container -->
</div>

<!-- Sliding Text -->
<section class="section-sm pt-0">
    <div class="sliding-text pb-3">
        <div class="container-fluid pd-0 overflow-hidden">
            <div class="row">
            <div class="col-12">
                <h2 class="display-1 fw-semi-bold mb-0 opacity-1 text-gradient-1 font-family-philosopher font-italic text-capitalize animate-left">Top Selling HTML Template. Maximo Multipurpose Template.</h2>
            </div>
            </div>
        </div>
    </div>
</section>
<!-- end Sliding Text -->